export const STATUS_META = {
  present: { label: "Present", dot: "bg-emerald-500", soft: "bg-emerald-50 text-emerald-700 border-emerald-200", text: "text-emerald-600" },
  half_day: { label: "Half Day", dot: "bg-orange-500", soft: "bg-orange-50 text-orange-700 border-orange-200", text: "text-orange-600" },
  absent: { label: "Absent", dot: "bg-red-500", soft: "bg-red-50 text-red-700 border-red-200", text: "text-red-600" },
  weekly_leave: { label: "Weekly Off", dot: "bg-blue-500", soft: "bg-blue-50 text-blue-700 border-blue-200", text: "text-blue-600" },
  govt_holiday: { label: "Govt Holiday", dot: "bg-amber-500", soft: "bg-amber-50 text-amber-800 border-amber-200", text: "text-amber-600" },
  paid_leave: { label: "Paid Leave", dot: "bg-purple-500", soft: "bg-purple-50 text-purple-700 border-purple-200", text: "text-purple-600" },
};

export const ACTIVITY_META = {
  at_office: { label: "At Office", gps: false },
  at_field: { label: "At Field", gps: true },
  meeting_client: { label: "Meeting With Client", gps: true },
};

export const MONTHS = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];

export const WEEKLY_OPTIONS = [
  { value: "sunday", label: "Sunday" },
  { value: "saturday", label: "Saturday" },
  { value: "saturday_sunday", label: "Saturday + Sunday" },
  { value: "none", label: "No Weekly Off" },
];

export function money(v) {
  const n = Number(v || 0);
  return "\u20b9" + n.toLocaleString("en-IN", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
